// utils/urls.ts
export const getWebsiteUrl = (path: string = "") => {
    const baseUrl = process.env.REACT_APP_FRONTEND_WEBSITE_URL || "https://playmix.ai";
    // console.log('website base url:', baseUrl);

    // Ensure path starts with /
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    const finalUrl = `${baseUrl}${normalizedPath}`
    // console.log('website final url:', finalUrl);
    return finalUrl;
};

export const navigateToWebsite = (path: string) => {
    const websiteUrl = getWebsiteUrl(path);
    window.location.href = websiteUrl;
};